<div class="sg-social-footer-icons main-icon">
  <div class="d-flex">
    <div class="icon-cont">
      <a class="social-icon" target="_blank" href="{{componentData.url}}" role="button">
        <i class="sg-icon sg-icon-facebook"></i>
      </a>
    </div>
  </div>
</div>